/// <amd-module name="Analytics/Views/AnalyticsViews" />
import * as React from "react";
import { LegacyComponent } from "VSS/Legacy/Legacy";
import { VssComponent } from "VSS/Platform/Layout";

interface AnalyticsViewsProps {}

class AnalyticsViews extends React.Component<AnalyticsViewsProps> {
    public render(): JSX.Element {
        return (
            <LegacyComponent
                modules={["Views/Scripts/AnalyticsHubShim"]}
                wrappedType="AnalyticsHub"
                dependentContributionIds={["ms.vss-analytics.analytics-service-context-data-provider"]}
            />
        );
    }
}

VssComponent.register("analytics-views", AnalyticsViews);
